module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-list",
    class: {
      isLoading: _vm.isLoading
    }
  }, [_c('mu-card', [_c('mu-content-block', {
    staticClass: "meal-list-header"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "600"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.mealTypeTitle) + "\n        ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_vm._t("button")], 2)], 1)], 1), _vm._v(" "), (!_vm.isLoading && _vm.foods.length === 0 && _vm.recipes.length === 0) ? _c('mu-card-text', [(_vm.mealType === 'breakfast') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoBreakfastLabel'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealType === 'lunch') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoLunchLabel'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealType === 'dinner') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoDinnerLabel'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealType === 'snack') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoSnackLabel'))
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('md-list', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dl-' + index,
      attrs: {
        "title": '',
        "disableRipple": ""
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "150px",
        "height": "8px",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#0179d5"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "margin-bottom": "16px",
        "height": "8px",
        "width": "80px",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#0179d5"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && (_vm.foods.length > 0 || _vm.recipes.length > 0)) ? _c('md-list', [((_vm.foods.length > 0 || _vm.recipes.length > 0) && !_vm.quickAddHidden) ? _c('div', {
    staticClass: "quickSaveNotice"
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "vertAlign",
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_vm._v("\n\n            " + _vm._s(_vm.$t('message.foodDiarySaveMealForNextTime')) + "\n\n          ")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "tooltip": _vm.$t('message.labelYes'),
      "icon": "check"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addToMealPlate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": _vm.$t('message.labelNo'),
      "icon": "close"
    },
    nativeOn: {
      "click": function($event) {
        _vm.quickAddHidden = true
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.recipes), function(item, index) {
    return (_vm.recipes.length > 0) ? _c('mu-list-item', {
      key: 'recipe-' + index
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('img', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ('Low Carb Program Recipe'),
        expression: "'Low Carb Program Recipe'",
        modifiers: {
          "top": true
        }
      }],
      staticStyle: {
        "position": "relative",
        "top": "4px",
        "margin-right": "4px"
      },
      attrs: {
        "width": "16",
        "src": "static/lcp-logo.svg"
      }
    }), _vm._v("\n\n            " + _vm._s(item.name) + "\n\n\n          ")]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "4px"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.servings + ' serving(s)')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nutrients"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrateShort')) + " " + _vm._s(_vm.decimalize(item.carbohydrate)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCaloriesShort')) + " " + _vm._s(_vm.decimalize(item.calories)) + "kcal · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')) + " " + _vm._s(_vm.decimalize(item.protein)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientTotalFatShort')) + " " + _vm._s(_vm.decimalize(item.fat)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientSaturatedFatShort')) + " " + _vm._s(_vm.decimalize(item.saturated_fat)) + "g")])])]), _vm._v(" "), _c('mu-icon-menu', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('View/Edit/Delete'),
        expression: "'View/Edit/Delete'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.labelViewNutrition')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.viewRecipeNutrients(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": "Go to recipe"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToRecipe(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openEditRecipeEntryDialog(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteRecipe(item, index)
        }
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.foods), function(food, index) {
    return (_vm.foods.length > 0) ? _c('mu-list-item', {
      key: 'food-' + index,
      attrs: {
        "title": food.food_name,
        "disableRipple": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [(food.brand_name !== '') ? _c('div', {
      staticClass: "brandName",
      domProps: {
        "textContent": _vm._s(food.brand_name)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      domProps: {
        "textContent": _vm._s(food.servings + ' x ' + food.serving_description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "nutrients"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrateShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.carbohydrate * food.servings)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCaloriesShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.calories * food.servings)) + "kcal · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')) + " " + _vm._s(_vm.decimalize(food.nutrients.protein * food.servings)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientTotalFatShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.fat * food.servings)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientSaturatedFatShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.saturated_fat * food.servings)) + "g")])])]), _vm._v(" "), _c('mu-icon-menu', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('View/Edit/Delete'),
        expression: "'View/Edit/Delete'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.labelViewNutrition')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.viewNutrients(food)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editFood(food)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteFood(food, index)
        }
      }
    })], 1)], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-flexbox', {
    staticClass: "nutritionalValues"
  }, [_c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrateShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.carbohydrate)) + "g\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCaloriesShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.calories)) + "kcal\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.protein)) + "g\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.nutrientTotalFatShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.fat)) + "g\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center last"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientSaturatedFatShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.saturated_fat)) + "g\n        ")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('md-dialog', {
    ref: "recipeNutritionDialog",
    staticClass: "nutrition-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.activeRecipeObject.name,
      "subTitle": _vm.activeRecipeObject.servings + ' serving(s)',
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeRecipeObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrients-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.decimalize(value) + _vm.getUnit(key)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "editRecipeDialog",
    staticClass: "edit-recipe-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.editRecipeEntryModel.name,
      "subTitle": " This food is added from the recipe area and is limited to modifying serving sizes only"
    }
  }), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateRecipeEntry.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-text-field', {
    attrs: {
      "fullWidth": "",
      "label": "Servings",
      "type": "number"
    },
    model: {
      value: (_vm.editRecipeEntryModel.servings),
      callback: function($$v) {
        _vm.$set(_vm.editRecipeEntryModel, "servings", $$v)
      },
      expression: "editRecipeEntryModel.servings"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isRecipeUpdating,
      "type": "button",
      "full-width": "",
      "label": _vm.$t('message.updateText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateRecipeEntry.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "disabled": _vm.isRecipeUpdating,
      "type": "submit",
      "full-width": "",
      "label": _vm.$t('message.updateText')
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "nutritionDialog",
    staticClass: "nutrition-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.activeFoodObject.food_name,
      "subTitle": _vm.activeFoodObject.servings + ' x ' + _vm.activeFoodObject.serving_description,
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeFoodObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.decimalize(value * _vm.activeFoodObject.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "mealPlateNamer",
    staticClass: "nutrition-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.foodDiaryMealPlateNameTitle'),
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMealPlate.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "nameText",
      "data-vv-as": _vm.$t('message.nameText'),
      "data-vv-value-path": "inputValue",
      "label": _vm.$t('message.nameText'),
      "hint-text": _vm.$t('message.placeholderText'),
      "full-width": ""
    },
    model: {
      value: (_vm.mealPlateName),
      callback: function($$v) {
        _vm.mealPlateName = $$v
      },
      expression: "mealPlateName"
    }
  })], 1)]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "secondarys": "",
      "disabled": _vm.isRecipeUpdating,
      "label": _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveMealPlate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b42921a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/MealList/MealList.vue
// module id = 3654
// module chunks = 1